<template>
  <SelectPopup
    :size="size"
    :closePopup="closePopup"
    :showLoading="showLoading">
    <div class="profile">
      <div class="profile-image">
          <img
            v-if="picture"
            :src="picture"
            alt="vlt-prof"
            class="profile-img-responsive" />
            <!-- <div class="profile-default" v-else>
              <p>G</p>
            </div> -->
          <img
          v-else
            :src="defaultPicture"
            style="margin-left: 10%;"
            alt="vlt-prof"
             />
            <div @click="openEditProfilePopup" class="profile-edit">
              <img src="@/assets/icons/edit.png" alt="edit icon"/>
            <!-- <span>Edit</span> -->
            </div>            
        </div>
        <p class="user-name">{{ AppUser.subscribername }}</p>
        <p class="user-email">{{ AppUser.email }}</p>
        <p @click="changePassword" v-if="changePasswordButton" class="change-password">Change Password</p>
    </div>
    <ul class="menu-ul">
      <div class="row"  @click="settings">
        <div class="col-xlg-2 col-lg-2 col-sm-2 col-xs-2 col-md-2">
         <img src="@/assets/icons/Settings.svg">
        </div>
        <div class="col-xlg-10 col-lg-10 col-sm-10 col-xs-10 col-md-10">
        <p class="meta-link">Settings</p>
        </div>
      </div>
      <div class="row" @click="logoutCB">
        <div class="col-xlg-2 col-lg-2 col-sm-2 col-xs-2 col-md-2">
         <img src="@/assets/icons/Signout.svg">
        </div>
        <div class="col-xlg-10 col-lg-10 col-sm-10 col-xs-10 col-md-10">
        <p class="meta-link">Sign Out</p>
        </div>
      </div>
      <!-- <li
        class="meta-link"
        @click="settings"
        >
        <img src="@/assets/icons/Settings.svg">
        Settings
      </li>
      <li
        class="meta-link"
        @click="logoutCB"
        >
        <img src="@/assets/icons/Signout.svg">
        Sign Out
      </li> -->
    </ul>
  </SelectPopup>
</template>

<script>
import SelectPopup from '@/components/Slots/SelectPopup.vue';
import User from '@/mixins/User';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { EventBus } from '@/main';
import GoogleAnalytics from '@/mixins/GoogleAnalytics';

export default {
  name: 'ProfieMenu',
  props: [
    'size',
    'closePopup',
    'showLoaderCB'
  ],
  data () {
    return {
      showLoading: false,
      showLogoutLink: false,
      changePasswordButton: false,
      defaultPicture: require('@/assets/icons/user-black.png'),
      loginMethod: null
    }
  },
  components: {
    SelectPopup
  },
  computed: {
    ...mapGetters([
      'subscriberid',
      'picture',
      'AppUser'
    ])
  },
  created () {

    if (localStorage.getItem('LoginType')) {
      let LoginType = JSON.parse(localStorage.getItem('LoginType'))
      this.loginMethod = LoginType.type
      if (LoginType.type == 'EMAIL')  {
        this.changePasswordButton = true;
      }
    }
    EventBus.$on('logoutError', (error) => {
      let GA = {
        'Event Label': 'Failure', 
        Status: 'FAILURE',
        ErrorCode: error.Code,
        ErrorMessage: error.Message
      }
      this.logoutEvent(GA)
    })
    EventBus.$on('logoutSuccess', () => {
      let GA = {
        'Event Label': 'Success',
        Status: 'SUCCESS'
      }
      this.logoutEvent(GA)
    })
  },
  methods: {
    ...mapMutations([
      'CommitConfigStore',
      'CommitUserStore',
    ]),
    ...mapActions([
      'actLogout'
    ]),
    changePassword () {
      this.closePopup ();
      EventBus.$emit('ChangePasswordPopup');
    },
    openEditProfilePopup () {
      this.closePopup ();
      EventBus.$emit('EditProfile');
    },
    logoutCB () {
      let GA = {
        MenuItem: 'Signout'
      }
      this.menuEvent(GA)
      //
      this.showLoading = true;
      if (this.loginMethod === 'FB') {
        FB.logout(function(response) {
          // console.log(response)
          // user is now logged out
        });
      }
      EventBus.$emit('logOut');
      this.closePopup ();      
    },
    settings () {
      let GA = {
        MenuItem: 'Settings'
      }
      this.menuEvent(GA)
      //
      this.closePopup ();
      this.$router.push({name: 'settings'});

    }
  },
  mixins: [ User, GoogleAnalytics ]
}
</script>

<style lang="scss">
.menu-ul{
  img{
    width: 25px;
  }
  .meta-link{
    cursor: pointer;
    font-size: 16px;
    margin-bottom: 10px;
    // opacity: 0.7;	
    color: #212121;	
    font-family: "ProximanovaSemibold";	
    line-height: 27px;
  }
}
.profile-image{
  text-align: center;
  .profile-img-responsive{
    margin-left: 10%;
    width: 80px;
    cursor: pointer;
    border-radius: 50%;
  }
  .profile-edit{
    float: right;
    cursor: pointer;
    img{
      width: 12px;
      opacity: 0.85;
      &:hover{
        opacity: 1;
      }
    }
  }
}
.user-name{
  text-align: center;
  text-transform: uppercase;
  font-size: 16px;
  color: black;
  font-family: "ProximanovaBold";
  font-style: normal;
  letter-spacing: 0.41px;	
  line-height: 27px;
}
.user-email{
  opacity: 0.75;	
  color: #212121;	
  font-family: "ProximanovaRegular";	
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
}
.profile{
  margin-bottom: 15px;
  border-bottom: 1px solid #eeeeee;
  p{
    text-align: center;
  }
}
.change-password{
  text-align: center;
  text-transform: uppercase;
  font-size: 12px;
  color: #4558DD;
  font-family: "ProximanovaSemiBold";
  font-style: normal;
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Right/ProfileMenu.vue